import { Injectable } from '@angular/core';
import { universityApi } from '../../constants/university-api';
import { HttpClientService } from '../httpClient/httpClient.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
    providedIn: 'root',
})
export class UniversityService {
    permissions_entity = permissionEntity;
    submitForms: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    // For catch university list
    private universityListSubject = new BehaviorSubject<any[]>([]);
    public universityList$ = this.universityListSubject.asObservable();

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) {}

    getAllUniversity(
        pagination: any
       
    ): Observable<any> {
        let query = '?';
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversity}${query}`;
        return this.httpClientService.get(url);
    }


    getUniversity(
        pagination: any,
        filters?: any,
        country?: any,
        search?: string,
        uni_country?: any,
        
    ): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (country) {
            query += `country=${country}&`;
        }
        if (uni_country) {
            query += `universityCountry=${uni_country}&`;
        }
        if (search) {
            query += `search=${search}&`;
        }
        // if (sort) { ///? for sorting
        //     query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        // }
        query += userParams.call(
            this,
            this.permissions_entity.modules.university
        );

        query += `sortDataOption=name&sortDataOrder=1&skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversity}${query}`;
        return this.httpClientService.get(url);
    }

    getUniversityByUniCountry(
        pagination: any,
        tenant: any,
        uni_country: any
    ): Observable<any> {
        const url = `${universityApi.getUniversityByUniCountry}${tenant}&universityCountry=${uni_country}&skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(url);
    }

    getUniversityEntry(
        pagination: PaginationType,
        filters?: any,
        sort: {sortDataOption:string, sortDataOrder:string} = null
    ): Observable<any> {
        let query = '?';

        if (filters) {
            query += filters;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        // query += this.userParams(this.permissions_entity.modules.universities_entry_requirement, filters.includes('tenant'));
        query += userParams.call(
            this,
            this.permissions_entity.modules.universities_entry_requirement,
            filters.includes('tenant')
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversityEntry}${query}`;
        return this.httpClientService.get(url);
    }

    postUniversityEntry(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.postUniversityEntry,
            payload
        );
    }

    getUniversityProcess(
        pagination: PaginationType,
        filters?: any
    ): Observable<any> {
        let query = '?';

        if (filters) {
            query += filters;
        }
        // query += this.userParams(this.permissions_entity.modules.universities_process_link);
        query += userParams.call(
            this,
            this.permissions_entity.modules.universities_process_link
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversityProcess}${query}`;
        return this.httpClientService.get(url);
    }

    getUniversityProcessApplication(
        pagination: PaginationType,
        filters?: any
    ): Observable<any> {
        let query = '?';

        if (filters) {
            query += filters;
        }
        // query += this.userParams(this.permissions_entity.modules.universities_process_link);
        query += userParams.call(
            this,
            this.permissions_entity.modules.universities_process_link
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversityProcessApplication}${query}`;
        return this.httpClientService.get(url);
    }

    postUniversityProcess(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.getUniversityProcess,
            payload
        );
    }

    updateShowAgent(uploadDocId: string): Observable<any> {
        return this.httpClientService.put(
          `${universityApi.updateUploadDocShowAgent}?uploadDocId=${uploadDocId}`,
          {}
        );
    }

    deleteUniversityProcessLink(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${universityApi.deleteUniversityProcessLink}${id}`
        );
    }

    getUniversityFilter(
        pagination: PaginationType,
        filters?: any
    ): Observable<any> {
        let query = '?';

        if (filters) {
            query += filters;
        }
        // query += this.userParams(this.permissions_entity.modules.universities_filter_master);
        query += userParams.call(
            this,
            this.permissions_entity.modules.universities_filter_master
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversityFilter}${query}`;
        return this.httpClientService.get(url);
    }

    postUniversityFilter(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.getUniversityFilter,
            payload
        );
    }

    getUniversityEditEntry(id: any): Observable<any> {
        const url = `${universityApi.getUniversityEntryById}/${id}`;
        return this.httpClientService.get(url);
    }

    putUniversityEntry(payload: any, id: string): Observable<any> {
        const url = `${universityApi.putUniversityEntry}?id=${id}`;
        return this.httpClientService.put(url, payload);
    }

    getUniversityProcessById(id: any): Observable<any> {
        const url = `${universityApi.getUniversityProcessById}/${id}`;
        return this.httpClientService.get(url);
    }

    putUniversityProcess(payload: any, id: string): Observable<any> {
        const url = `${universityApi.getUniversityProcess}?id=${id}`;
        return this.httpClientService.put(url, payload);
    }

    putUniversityFilter(payload: any, id: string): Observable<any> {
        const url = `${universityApi.getUniversityFilter}?id=${id}`;
        return this.httpClientService.put(url, payload);
    }

    getUniversityEditFilter(id: any): Observable<any> {
        const url = `${universityApi.getUniversityFilter}/${id}`;
        return this.httpClientService.get(url);
    }
    postUniversity(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.postuniversity,
            payload
        );
    }
    updateUniversity(payload: any, id): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.postuniversity}?universityId=${id}`,
            payload
        );
    }

    updateEntryReq(payload: any, id): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.updateEntryReq}?Id=${id}`,
            payload
        );
    }

    getUniversityCommission(): Observable<any> {
        const url = `${universityApi.getUniversityCommission}`;
        return this.httpClientService.get(url);
    }

    universityAdmin(id: any): Observable<any> {
        return this.httpClientService.get(
            `${universityApi.universityAdmin}${id}`
        );
    }

    getUniversityDoc(id: any): Observable<any> {
        return this.httpClientService.get(
            `${universityApi.getUniversityDoc}${id}`
        );
    }
    getAssignedUniversities(assign? : any): Observable<any> {
        let query = '?';
        if (assign) {
            query += `viewStatus=${assign}`;
        }
        return this.httpClientService.get(
            `${universityApi.getAssignedUniversities}${query}`
        );
    }

    getUniversityEmail(
        pagination: PaginationType,
        filters?: any
    ): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        // query += this.userParams(this.permissions_entity.modules.universities_email);
        query += userParams.call(
            this,
            this.permissions_entity.modules.universities_email
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversityEmails}${query}`;
        return this.httpClientService.get(url);
    }

    getUniversityEmailsById(id: any): Observable<any> {
        const url = `${universityApi.getUniversityEmailsById}${id}`;
        return this.httpClientService.get(url);
    }

    postUniversityEMail(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.addUniversityEmails,
            payload
        );
    }

    updateUniversityEMail(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.updateUniversityEmails}${id}`,
            payload
        );
    }

    deleteUniversityEmail(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${universityApi.deleteUniversityEmail}${id}`
        );
    }

    getUniversityPG(pagination: any, filters?: any): Observable<any> {
        let query = '?';

        if (filters) {
            query += filters;
        }
        // query += this.userParams(this.permissions_entity.modules.university_filter_pg);
        query += userParams.call(
            this,
            this.permissions_entity.modules.university_filter_pg
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(
            `${universityApi.getUniversityPG}${query}`
        );
    }

    getUniversityPGById(id: any): Observable<any> {
        const url = `${universityApi.getUniversityPGById}${id}`;
        return this.httpClientService.get(url);
    }

    postUniversityPG(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.addUniversityPG,
            payload
        );
    }

    updateUniversityPG(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.updateUniversityPG}${id}`,
            payload
        );
    }

    deleteUniversityPG(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${universityApi.deleteUniversityPG}${id}`
        );
    }

    getUniversityUG(pagination: any, filters?: any): Observable<any> {
        let query = '?';

        if (filters) {
            query += filters;
        }
        // query += this.userParams(this.permissions_entity.modules.university_filter_ug);
        query += userParams.call(
            this,
            this.permissions_entity.modules.university_filter_ug
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversityUG}${query}`;
        return this.httpClientService.get(url);
    }

    getUniversityUGById(id: any): Observable<any> {
        const url = `${universityApi.getUniversityUGById}${id}`;
        return this.httpClientService.get(url);
    }

    postUniversityUG(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.addUniversityUG,
            payload
        );
    }

    updateUniversityUG(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.updateUniversityUG}${id}`,
            payload
        );
    }

    deleteUniversityUG(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${universityApi.deleteUniversityUG}${id}`
        );
    }

    getUniversityAffiliate(pagination: any, filters?: any, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
        let query = '?';

        if (filters) {
            query += filters;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        // query += this.userParams(this.permissions_entity.modules.university_affiliate);
        query += userParams.call(
            this,
            this.permissions_entity.modules.university_affiliate
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        const url = `${universityApi.getUniversityAffiliate}${query}`;
        return this.httpClientService.get(url);
    }

    getUniversityAffiliateById(id: any): Observable<any> {
        const url = `${universityApi.getUniversityAffiliateById}${id}`;
        return this.httpClientService.get(url);
    }

    postUniversityAffiliate(payload: any): Observable<any> {
        return this.httpClientService.post(
            universityApi.addUniversityAffiliate,
            payload
        );
    }

    updateUniversityAffiliate(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.updateUniversityAffiliate}${id}`,
            payload
        );
    }

    deleteUniversityAffiliate(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${universityApi.deleteUniversityAffiliate}${id}`
        );
    }

    uploadUniversityDoc(id: any, payload: any): Observable<any> {
        return this.httpClientService.upload(
            `${universityApi.uploadUniversityDoc}${id}`,
            payload
        );
    }

    getUniversityById(id: any): Observable<any> {
        const url = `${universityApi.getUniversityById}${id}`;
        return this.httpClientService.get(url);
    }

    getUniversityUploadDoc(u_id: any, pagination: any): Observable<any> {
        const url = `${universityApi.getUniversityUploadDoc}${u_id}&skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(url);
    }

    addUniversityUploadDoc(payload: any, university_id: any): Observable<any> {
        return this.httpClientService.upload(
            `${universityApi.addUniversityUploadDoc}${university_id}`,
            payload
        );
    }

    deleteUniversityUploadDoc(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${universityApi.deleteUniversityUploadDoc}${id}`
        );
    }

    getUniversityCourses(
        id: any,
        pagination: PaginationType,
        filters?: any,
        intakeId?: any
    ): Observable<any> {
        let query = '&';
        if (intakeId) {
            query += `intake=${intakeId}&`;
        }
        if (filters) {
            query += filters;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${universityApi.getUniversityCourse}${id}${query}`
        );
    }

    updateUniversityCourses(id: any, payload: any): Observable<any> {
        const url = `${universityApi.getUniversityCourse}${id}`;
        return this.httpClientService.put(url, payload);
    }

    getListOfApplicationProcessCATCPTART(
        pagination: PaginationType,
        filters?: any
    ): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        // query += this.userParams(this.permissions_entity.modules.university_cat_cpt_art);
        query += userParams.call(
            this,
            this.permissions_entity.modules.university_cat_cpt_art
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${universityApi.getListOfApplicationProcessCATCPTART}${query}`
        );
    }

    getSingleApplicationProcessCATCPTART(
        universityId: string
    ): Observable<any> {
        return this.httpClientService.get(
            `${universityApi.getSingleApplicationProcessCATCPTART}${universityId}`
        );
    }

    getAssignedUserInfor(payload: Object) {
        return this.httpClientService.post(
            universityApi.getAssignedUserInfo,
            payload
        );
    }

    updateApplicationProcessCATCPTART(payload: Object) {
        return this.httpClientService.post(
            universityApi.updateApplicationProcessCATCPTART,
            payload
        );
    }

    getUniversityURM(): Observable<any> {
        const url = `${universityApi.getUniversityURM}`;
        return this.httpClientService.get(url);
    }

    getUniversityURMForMail(
        pagination: PaginationType,
        search: string
    ): Observable<any> {
        let query = '?';
        if (search) {
            query += `name=${search}&`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(
            `${universityApi.getUniversityURMList}${query}`
        );
    }

    getFormsByUniversity(uniId: any): Observable<any> {
        return this.httpClientService.get(
            `${universityApi.getFormByUniversity}${uniId}`
        );
    }
    
    getUniversityByIds(universityIds: any): Observable<any> {
        let query = '?'
        if(universityIds){
            query +=`universityIds=${universityIds}`
        }
        return this.httpClientService.get(
            `${universityApi.getUniversityByIds}${query}`
        );
    }

    getAllUniversitiesWithoutFilters(
    ): Observable<any> {
        const url = `${universityApi.getUniversityByUniCountry}${1}&skip=${0}&limit=${700}`;
        return this.httpClientService.get(url);
    }

    getUniversityByUniCountryV2(
        pagination: PaginationType,
        cpurseType,
        tenant_id?: any,
        university_country?: string,
        search?: string,
        intake?: any,
        country?: any
    ): Observable<any> {
       
        let query = '?';
        if (tenant_id) {
            query += `tenant=${tenant_id}&`;
        }
        if (cpurseType) {
            query += `courseType=${cpurseType}&`;
        }
        if (university_country) {
            query += `universityCountry=${university_country}&`;
        }
        if (search) {
            query += `search=${search}&`;
        }
        if (intake) {
            query += `intake=${intake}&`;
        }
        if (country) {
            query += `country=${country}&`;
        }

        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${universityApi.getUniversityForApplyCourse}${query}`
        );
    }

    getUniversityWitheligibility(
        pagination: PaginationType,
        cpurseType,
        tenant_id?: any,
        university_country?: string,
        search?: string,
        intake?: any,
        country?: any
    ): Observable<any> {
        let query = '?';
        if (tenant_id) {
            query += `tenant=${tenant_id}&`;
        }
        if (cpurseType) {
            query += `courseType=${cpurseType}&`;
        }
        if (university_country) {
            query += `universityCountry=${university_country}&`;
        }
        if (search) {
            query += `search=${search}&`;
        }
        if (intake) {
            query += `intake=${intake}&`;
        }
        if (country) {
            query += `country=${country}&`;
        }

        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        console.log(universityApi.getUniversityForApplyCourse);

        return this.httpClientService.get(
            `${universityApi.getUniversityForApplyCourse}${query}`
        );
    }

    saveUniversityFormRequirment(payload): Observable<any> {
        return this.httpClientService.post(
            `${universityApi.saveUniversityFormRequirment}`,
            payload
        );
    }

    getUniversityFormRequirment(universityId?, countryId?, educationLevel?): Observable<any> {
        let query = '?';
        if (universityId) {
            query += `universityId=${universityId}&`;
        }
        if (countryId) {
            query += `countryId=${countryId}&`;
        }
        if (educationLevel) {
            query += `educationLevelId=${educationLevel}&`;
        }
        return this.httpClientService.get(
            `${universityApi.saveUniversityFormRequirment}${query}`,
        );
    }

    putUniversityFormRequirment(payload): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.saveUniversityFormRequirment}?id=${payload.id}`,
            payload
        );
    }
    getPresentation(id,pagination: PaginationType){
        let query = '&';
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${universityApi.addUniversityUploadDoc}${id}${query}`
        );
    }

    createQuestion(payload): Observable<any> {
        return this.httpClientService.post(
            `${universityApi.createQuestion}`,  
            payload
        );
    }

   twoFactorAuth(payload): Observable<any> {
        return this.httpClientService.put(
            `${universityApi.updateUniversityFormSetting}`,
            payload
        );
    }

    deleteUniversityFormRequirment(id): Observable<any> {
        return this.httpClientService.delete(
            `${universityApi.deleteUniversityFormRequirment}?Id=${id}`
        );
    }
}
